import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPayrollEntry = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Payroll Entry',
    body
  );
  return data;
});
export const updatePayrollEntry = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Payroll Entry/${id}`,
    body
  );
  return data;
});

export const getPayrollEntry = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Payroll Entry?fields=["name","docstatus","salary_slips_created","salary_slips_submitted","start_date","end_date"]'
  );
  return data;
});
export const deletePayrollEntry = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Payroll Entry/${record}`
  );
  return data;
});
export const getPayrollEntryDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Payroll Entry/${id}`);
  return data;
});
export const getCompanyDetailsPayroll = catchAsync(async (Company) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_data?type=Company&name=${Company}&fields=["default_payroll_payable_account","cost_center"]`
  );
  return data;
});
export const CreateSalarySlipsPayroll = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.create_salary_slips?name=${id}`
  );
  return data;
});
export const SubmitSalarySlipsPayroll = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.submit_salary_slips?name=${id}`
  );
  return data;
});
export const getEmployeesPayroll = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.salary_slip_get_employees?name=${id}`
  );
  return data;
});
export const getPayrollEntryHasBank = catchAsync(async (id) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.payroll_entry_has_bank?name=${id}`
  );
  return data;
});
export const AddPayrollEntryMakeBank = catchAsync(async (id) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.payroll_entry_make_bank?name=${id}`
  );
  return data;
});
